export default "__VITE_ASSET__DluSHEr6__"